module.exports = __webpack_public_path__ + "img/P62-zh.8864d730.png";